export default "__VITE_ASSET__CvTwF16w__"